import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { registrationFormMetadataSchema } from './formDataSchema';
import {
  IIndirectTaxGetRegistrationFormDataParams,
  IIndirectTaxGetRegistrationFormDataResponse,
  IIndirectTaxRegistrationFormDataApiResponse,
} from './types';

export function useIndirectTaxRegistrationFormData({
  registrationId,
  corporationId,
}: IIndirectTaxGetRegistrationFormDataParams) {
  const { data, mutate, error, isLoading } =
    useSWR<IIndirectTaxGetRegistrationFormDataResponse>(
      registrationId && corporationId
        ? `new-sales-tax/registrations-v2/${registrationId}/form-data?corporationId=${corporationId}`
        : null,
      async (url: string) => {
        const response: IIndirectTaxRegistrationFormDataApiResponse =
          await SWRFetcher({ method: 'GET' })(url);
        return {
          ...response,
          metadata:
            registrationFormMetadataSchema.nullish().parse(response.metadata) ??
            null,
        };
      }
    );

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
